import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AppState } from './app.reducer';

export const selectAppState = createFeatureSelector<AppState>('app');

export const isLoading = createSelector(selectAppState, (state) => state.isHttpLoading || state.customLoaders.length > 0);

export const selectAvailableLanguages = createSelector(selectAppState, (state) => state.availableLanguages);

export const selectCurrentLanguage = createSelector(selectAppState, (state) => state.language);

export const selectAppDirection = createSelector(selectCurrentLanguage, (lang) => {
  const rtlLanguages = ['ar', 'he', 'fa', 'ur'];
  return rtlLanguages.includes(lang) ? 'rtl' : 'ltr';
});
